// Module
var code = "<div class=\"spimCopy-wrapper\"> <span class=\"not-selected\"><!-- ko text: $parent._labels.CLASS_NOT_SELECTED --><!-- /ko --></span> <a data-bind=\"click: $parent.Search.bind($parent,true)\" href=\"#\" class=\"btn blue-sharp\"> <!-- ko text: $parent._labels.SEARCH --><!-- /ko --> </a> </div>";
// Exports
export default code;